import useScrollRestoration from '../../hooks/useScrollRestoration'

const ScrollToTop = () => {
  useScrollRestoration()
  return null // Componente sin UI
}

export default ScrollToTop
